import { Target, Zap, TrendingUp, Users, Video, FileText, Edit3, Image as ImageIcon, Package, Search } from 'lucide-react';

export const mockData = {
  hero: {
    preHeadline: "Business Owners Looking for High-Ticket Clients From Youtube...",
    headline: "We will get you qualified leads from YouTube. You only pay per result.",
    subheadline: "We handle everything from scripting, ideating, posting, and editing completely done-for-you. All you have to do is talk in front of a camera for 2 hours per month."
  },

  testimonials: [
    {
      name: "Eddie Cumberbatch",
      company: "Growth Operator",
      quote: "Eddie, the original 'growth operator' was able to scale his business from $54,000/mo to $430,000/mo in 4 months working with us...",
      image: "EC"
    },
    {
      name: "Daniel Fazio",
      company: "Client Ascension & Listkit",
      quote: "It is a directly attributable revenue of working with you on my YouTube, of about $108,000 to this day",
      image: "DF"
    },
    {
      name: "Matt Lucero",
      company: "Anevo Marketing",
      quote: "I didn't even do anything... our videos ranked in search and got 3 calls booked. They were all insanely qualified. 10k+ worth of opportunities right there.",
      image: "ML"
    },
    {
      name: "Othmane Baddou",
      company: "ScaleByMetrics",
      quote: "I collected $3,500 after about 3 weeks... closing the first client with only a few hundred views per video was mind blowing for me",
      image: "OB"
    },
    {
      name: "Charles Tichenor",
      company: "Disrupter School",
      quote: "Absolutely... I can say, as my adsense (YouTube ad revenue) goes up, the revenue of my business goes up... Which tells you how closely related those 2 things are.",
      image: "CT"
    }
  ],

  problems: [
    {
      title: "Hire a random editor and hope for the best",
      description: "YouTube success isn't about flashy cuts and cool music. It's about strategy - what to say, how to say it, and how to link it back to your offer. Most editors can't help with that. They just make things 'look' nice and try to make flashy edits."
    },
    {
      title: "Trust that your 'value' will be enough to book calls",
      description: "Yes, valuable content is important. But so is the packaging, SEO, thumbnail, editing. Without the proper strategy, and packaging the Gamma Doc Presentation you spent 3 hours building will be for nothing..."
    },
    {
      title: "Study what makes content go viral & try to replicate it",
      description: "Understanding how Mr. Beast grew a 400M subscriber audience isn't going to help your coaching program book more sales calls... neither is reverse engineering Alex Hormozi content. You need to understand the fundamentals of content that books calls for YOUR offer."
    },
    {
      title: "Try to do everything yourself",
      description: "Scriptwriting. Filming. Editing. Thumbnails. SEO. Posting. If you're handling it all, no wonder YouTube instantly goes on the back-burner when you sign a new client. Consistency is everything with YouTube - you can't afford to have big gaps between uploads."
    }
  ],

  benefits: [
    {
      title: "Consistently book your best sales calls",
      description: "YouTube is where prospects go when their pain is at its peak. They're not scrolling on the toilet, they're searching. Looking for answers. Ready to pay someone who gets it. When your content shows up in that moment, it's a lay-up deal."
    },
    {
      title: "Improve results on your ads, emails, and cold outreach, instantly",
      description: "When you post on YouTube, suddenly your ads get higher ROAS. Your cold email replies are warmer. Your lead quality improves across the board, because they've already seen your content beforehand."
    },
    {
      title: "Fewer no-shows, ghosted DMs, and 'just curious' leads",
      description: "YouTube filters out the time-wasters. People self-qualify through your content, so by the time they hit 'Book a Call,' they already know they want in."
    },
    {
      title: "Your Closers (or you) turn into cashiers, not salespeople",
      description: "When someone watches 45 minutes of your content before the call… they show up ready to buy, not to be sold. You don't need to build rapport or 'press their pain' - just the link to the invoice."
    },
    {
      title: "Create compounding lead flow (even while you sleep)",
      description: "Unlike ads or short-form, YouTube content ranks, gets searched, and shows up in feeds months, even years, after it goes live - bringing in leads on autopilot from videos you forgot you even posted."
    },
    {
      title: "You become the obvious choice, even in a crowded market",
      description: "When you show up in the right person's feed with the right message, over and over, you instantly become the one they trust. YouTube makes that possible, without needing a massive audience."
    }
  ],

  services: [
    {
      title: "Video Ideation",
      description: "We research what's working in your niche, analyze your offers, and map out a full content calendar designed to attract the exact type of clients you want - not just views.",
      icon: Target
    },
    {
      title: "Video Scripting",
      description: "We ask one thing of you: Record once a week. We make this even simpler by scripting out the entire video for you. So that you can focus 99% of your time on your business and 1% on YouTube",
      icon: FileText
    },
    {
      title: "Video Editing",
      description: "We handle all editing with a focus on clarity, retention, and attention to detail. We don't over-edit. We don't use templates - your style is unique and works with your ICP.",
      icon: Edit3
    },
    {
      title: "Thumbnail Design",
      description: "Most thumbnails look like a Canva template from 2014. Ours are designed to actually get clicked, based on what's trending, what's proven, and what feels like you.",
      icon: ImageIcon
    },
    {
      title: "Video Packaging",
      description: "We handle the boring stuff: titles, descriptions, tags, timestamps, pinned comments, metadata, all done properly so your video is positioned to get discovered and convert.",
      icon: Package
    },
    {
      title: "Search Engine Optimization",
      description: "YouTube is the second biggest search engine on the planet. We make sure your content is optimized to rank for the right keywords - so you're not just relying on the algorithm.",
      icon: Search
    }
  ],

  comparison: {
    without: [
      "Sling out tons of objections",
      "Ask 'what do you do again?' halfway through the call",
      "Are cruel, guarded, and cold",
      "Need 2-3 follow-ups just to make a decision"
    ],
    with: [
      "Come in warm, educated, and ready to buy",
      "Show up to sales calls informed, not asking surface level questions",
      "Already see you as the expert in the space",
      "Repeat your messaging back to you word-for-word",
      "Show up already sold on working with you"
    ]
  },

  faqs: [
    {
      question: "What exactly do you help with?",
      answer: "We handle the entire YouTube growth strategy for you - from scripting and editing to SEO, thumbnails, and posting. You just show up to record once a week. Everything else is done-for-you with a focus on getting you more qualified inbound leads."
    },
    {
      question: "Why YouTube?",
      answer: "YouTube is where buyers go when they're actively searching for a solution. It's high-intent, evergreen, and compounds over time - unlike short-form, ads, or cold outreach. One good video can drive leads for months (or years) without spending a penny on traffic."
    },
    {
      question: "I'm already seeing good results from other client acquisition methods. Why do I need this?",
      answer: "YouTube is unique in the sense that it's not just a linear acquisition channel. The value of one video doesn't stop after it's published. It keeps working. It builds trust while you sleep. It pre-sells for you while you're on calls. It warms up leads that found you from cold ads, referrals, SEO, or outbound."
    },
    {
      question: "How much time will this take me?",
      answer: "Most clients spend just 60-90 minutes a week filming. Or they batch record for a few hours once per month. We handle everything else, scripting, editing, posting, optimization, so you can focus on what you do best."
    },
    {
      question: "How do I know this will actually work for me?",
      answer: "This system isn't built for influencers. It's built for operators. Founders. Coaches. Agency owners. People who know how to close, they just need more warm, ready-to-buy prospects. If you've got a solid offer, you're good on camera (or at least willing to try), and you can commit to one video per week… we'll handle the rest."
    },
    {
      question: "Do I need to come up with the content ideas myself?",
      answer: "No. We ideate the topics, research the angles, and write the entire script. You just show up and record with a strategy that's already working."
    },
    {
      question: "What kind of results can I expect?",
      answer: "While results do differ depending on 101 different factors... You can typically expect your first inbound sales calls after 1 month of consistent posting. After that, the number compounds exponentially."
    },
    {
      question: "How is this different from hiring a video editor or freelancer?",
      answer: "We bring strategy. From ideation to scripting to thumbnail to SEO - we build your channel like a high-converting funnel, not a 'content machine.'"
    },
    {
      question: "Do I need a big audience for this to work?",
      answer: "Not at all. Some of our best-performing clients had under 300 subscribers when they started. YouTube is search-based - which means you show up in front of buyers, not followers."
    },
    {
      question: "What if I've tried YouTube before and it didn't work?",
      answer: "That's exactly why we exist. Most people fail because they post without strategy, poor editing, no optimization, and zero consistency. We fix all of that."
    }
  ]
};